import { io } from 'socket.io-client';

// Socket server creation
export default io(process.env.VUE_APP_BACK_URL);
